'use strict';
var global = require('../internals/global');

module.exports = function (CONSTRUCTOR, METHOD) {
  var Constructor = global[CONSTRUCTOR];
  var Prototype = Constructor && Constructor.prototype;
  return Prototype && Prototype[METHOD];
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/get-built-in-prototype-method.js
// module id = 367
// module chunks = 0